// removed by extract-text-webpack-plugin
module.exports = {"Dropzone":"Dropzone__2R9mTscmerc7","Curtain":"Curtain__3SnXnkNML4C9","Indicator":"Indicator__MkpBCU_hJZw1","ButtonHint":"ButtonHint__2JsEVtbjLcMS"};